import { render } from "./ProductRatingFrame.vue?vue&type=template&id=6116c7f9&scoped=true"
import script from "./ProductRatingFrame.vue?vue&type=script&lang=js"
export * from "./ProductRatingFrame.vue?vue&type=script&lang=js"

import "./ProductRatingFrame.vue?vue&type=style&index=0&id=6116c7f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6116c7f9"]])

export default __exports__